export default {
      id: "modal-close-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#modal-close",
      toString: function () {
        return this.url;
      }
    }